import sanityClient from "@sanity/client";
import ImageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: "jlbvii0k",
  // projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: true,
  // token: process.env.REACT_APP_SANITY_TOKEN,
  token:
    "skvoJUaKGq5Yd4gsnsQAYbinyYxFw5NxnE8r2Azvmvi7QOap8MTXyiqxEmEo8GrsCwwIYIrp0VszxGuPKo5vwdNu0Vbc4O2TlxzEGVeXRIY1q29p9UJCbobm6BM7mK2A3sCAfLJceXtFEGJJbRNqjOV41DR5dvJtim9B8YubP3tocGrWxBKj",
});

const builder = ImageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

// fixed boilerplate
